var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReturn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.139893,
    width: 18,
    height: 18,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_6757_907",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_6757_907",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAADRUlEQVR4nO2cu2pVQRSGPy+JqRTvlfEBRMFLI1ZeOBhRFNS3MImlGsFOYmkX7NVCyStItBHtEwVtRGOhiYLC8eBly4YJiOiZSbJnr9l7/g9Wl0PW+v99mVkzs0EIIYQQQgghRLacBK5bJ5ErHaALFMCkdTI5i1/IBHvxC5lgL34hE+K/cLse8ZdCL2aDK79w0QNOV51Azkh8QyS+IRLfEIlviMQ3ROIbIvENkfiGSHxDJL4hEt8QiW+IxDdE4hsi8Q2R+A1ZyWpq9IBF4DUwA9wBLgMHgXWW4p/IQPzCE6Ux94FTwPo6xT8CfE1AgCKheA9cAzbFFv8Q8DmBgotE4xMwAWyQAZga8RI4HsuEw8CXBK62IvH4BdwGBmKYoJcwwUY8AbZazwFyjzlg2Hou0HV/3yQGgM3AHuA8cBN4CvxcgQlvZEJ17AKuAm+XacJsrMdR2++E/1EONy8BC8sw4XGsiVuuJpRsBx4sw4RoB09yNgF3N3wPHKIeIxK5m3A2sP4XMWfMMgF+BJhQ9o+ikbsJo4Ed1Y0xk8jdhIfWd0HuJuxwV3m/mufrWE/I2YTRgJrLRZ3o5GrCEPDOU++9upLJ1YQJT63lTHptqjspztB8hgMaeAfqTCjHO+GZp87xuhPK7U6Y9NQ4ZZFUTiZc8NT3yCqxXD5VsNdTW7n5y4xOgAk3aDbbPPV9sE6w08eEpouP63z2M+AbCdD5hwltEL8xBvxtQlvEb8QjqO0f7Uv6JZwDF1MdhubCrRQnYjnxPLVWRE7sDmjG7bdOss342tEf62xH58aQW3bsZ8Bd6yTbzFhAj2vEOsm2stMdWzJflM+RNcB0wNVf7rIWERhPYWNWrpwL3Jp4xTrRtorfDTy2NGidbNue+eOBV345KTtqnXDbRjvTAcIvRXnWTFQ0yRoLGGr+GeVHPzTsrGCj1UTADLe2Q3ptZRDYAuxz20omXVczmWOqvn/a9N8XFcVsrIPaqQvoow7xZ2I+dlIX0EdjP9YRWkDTf1+sMObqGuenLqCPqoVfdO2F2ma4qQvooyrh511Xs/bGWuoC+liN6AtuJWvE8guKqQu42t/3nNCv3L6dKdfvKU+zaA1XCCGEEEIIwWr5Df2K7E4pZGctAAAAAElFTkSuQmCC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturn);
export default __webpack_public_path__ + "static/media/Return.890746a8.svg";
export { ForwardRef as ReactComponent };